export default "__VITE_ASSET__DMfiTjUs__"